import { connect } from "react-redux";
import get from "lodash/get";

import { handleRecievePopupNotification as onRecievePopupNotification } from "../../actions/signalRActions";

const mapStateToProps = (state) => ({
  dataRecievePopupNotification: state.popupNotifications.dataRecievePopupNotification,
  error: get(state, ["popupNotifications", "error"], null),
});

const mapDispatchToProps = {
  onRecievePopupNotification,
};

const withPopupNotification = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withPopupNotification };
